<div class="spinner" *ngIf="!hide">
  <div class="bounce1" [ngStyle]="{ 'background-color': color }"></div>
  <div class="bounce2" [ngStyle]="{ 'background-color': color }"></div>
  <div class="bounce3" [ngStyle]="{ 'background-color': color }"></div>
</div>
